import { Button, Stack, styled, Typography } from '@mui/material';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EconsultTextField, SearchSVGIcon } from '@oh-vcp/components-ui';
import { useNavigate, useParams } from 'react-router-dom';
import { CaseResponsePayloadDTO, EconsultUtils } from '@oh-vcp/components-common';

const SearchTextField = styled(EconsultTextField)({
  '& .MuiOutlinedInput-root': {
    borderRadius: 0
  }
});

const SearchButton = styled(Button)({
  borderRadius: 0,
  '&:hover': {
    backgroundColor: '#77B800'
  }
});
interface EconsultCaseSearchBoxProps {
  setResultsToDisplay: (updResultsDisplay: CaseResponsePayloadDTO | undefined) => void;
}
const EconsultCaseSearchBox: FC<EconsultCaseSearchBoxProps> = ({ setResultsToDisplay }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { statusType } = useParams();
  const [keyword, setKeyword] = useState<string>('');
  const validFieldMessageType = {
    display: 'none'
  };
  const inValidFieldMessageType = {
    display: 'block',
    color: 'red',
    fontSize: '0.95rem'
  };
  const [errorMessageStyle, setErrorMessageStyle] = useState(validFieldMessageType);
  const handleKeywordChanged = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setKeyword(event.target.value);
    setErrorMessageStyle(validFieldMessageType);
  };
  const searchTxtRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (statusType && !keyword) {
      setKeyword(statusType);
    }
  }, [statusType]);

  useEffect(() => {
    if (EconsultUtils.isMobileDevice() && searchTxtRef.current) {
      searchTxtRef.current.focus();
    }
  }, []);
  const handleCaseSearch = () => {
    if (keyword && keyword.length > 1) {
      setErrorMessageStyle(validFieldMessageType);
      navigate(`/case/search/${keyword}`);
    } else {
      setErrorMessageStyle(inValidFieldMessageType);
      setResultsToDisplay(undefined);
    }
  };
  const searchBoxWidth = EconsultUtils.isMobileDevice() ? '260px' : '100%';
  return (
    <Stack direction="column">
      <Stack direction="row">
        <SearchTextField
          fullWidth
          type="search"
          placeholder={t('Case.search.searchForCases') as string}
          value={keyword}
          ref={searchTxtRef}
          onChange={handleKeywordChanged}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleCaseSearch();
            }
          }}
          sx={{
            width: searchBoxWidth
          }}
        />
        <SearchButton variant="contained" onClick={handleCaseSearch}>
          <SearchSVGIcon />
        </SearchButton>
      </Stack>
      <Typography id="searchValidationdMessage" style={errorMessageStyle}>
        {t('Case.search.keywordInvalid')}
      </Typography>
    </Stack>
  );
};

export default EconsultCaseSearchBox;
